import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import * as emiGlobals from 'app/globals';
import { HttpService } from 'app/shared/services/http.service';
import { WidgetReportItem } from 'app/shared/widget/widget-item';
import { QuestionsComponent } from 'app/calculators/home-loan-comparison-calculator/questions/questions.component';
import { WidgetHostService } from 'app/shared/widget/widget-host-service';
import { WidgetHostDirective } from 'app/shared/widget/widget-host.directive';
import { CalculatorService } from 'app/calculators/calculator.service';
import { Product, ProductOffer } from 'app/calculators/Product';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-dynamic-products',
  templateUrl: './dynamic-products.component.html',
  styleUrls: ['./dynamic-products.component.css']
})
export class DynamicProductsComponent implements OnInit, AfterViewInit {

  @ViewChild('bank', { read: WidgetHostDirective }) bank; // For dynmaic component loading
  @ViewChild('clickableDiv') clickableDiv: ElementRef;
  
  
  
  
  
  productList = [];
  dataList: any;
  statusList: any;
  url: any;
  productId: any;
  inputValuesList: any;
  customProduct: any;

  showStatus: boolean;
  companySpecificpage: boolean;

  product: Product = new Product();
  productOffer: ProductOffer = new ProductOffer();
  offerforproduct: any;
  offerleadid: any;
  
  constructor(public httpService: HttpService, public widgetHostService: WidgetHostService,
    public calculatorService: CalculatorService, public route: ActivatedRoute,
    private datePipe: DatePipe, private el: ElementRef) {
  }
  ngAfterViewInit(): void {
   // throw new Error('Method not implemented.');
   /* const divContent = this.el.nativeElement.innerText.trim();
    if (divContent === 'Salaried') {
      this.el.nativeElement.click();
    } */
    // alert("after view init")
   
  }
  
  
  ngOnInit() {

    this.route.queryParams.subscribe(result => {
      // company specific page
       this.offerforproduct = result['product'];
       this.offerleadid = result['leadId'];
      //alert(this.offerforproduct)
       if (result['companygrp']) {
        this.route.params.subscribe(parms => {
          this.productOffer.groupId = parms['calculator-slug'];
          
        });
        this.companySpecificpage = true;
        this.showStatus = true;

        // To display products
        this.httpService.getAll(emiGlobals.productsBasedOnCompanyGroup + '/' + this.productOffer.groupId).subscribe(response => {
          debugger
          this.productList = response.products;
        });
      } else {  // product specific page
        this.route.params.subscribe(data => {
          this.url = data['calculator-slug'];
          
        });
        this.getAllProducts(this.url);
        this.httpService.getAll(emiGlobals.productByUrlCategory + '/' + this.url).subscribe(value => {
            this.customProduct = value.sub_products[0];
            this.calculatorService.activeProduct = this.customProduct.id;
            this.product.productId = this.customProduct.id;
            this.product.questionType = this.customProduct.question_type;
            this.product.listId = this.customProduct.list_type;
            /* if(this.offerforproduct != undefined)
            {
            let element = document.getElementById('Salaried') as HTMLElement;
            element.click();
          } */
          });
      }
    });
    // To get All status List
    // this.httpService.getAll(emiGlobals.statusUrl).subscribe(result => {
    //   this.statusList = result.status;
      
    // });
    this.calculatorService.SearchCategory = '2';
  }
  
  



  ngAfterContentChecked(){
    //alert("after content checked")
    let element = null;
    element = document.getElementById('Salaried') as HTMLElement;
    // if (element && this.offerforproduct != undefined)
//  if (element &&  this.offerleadid  != undefined )
//   {
//     element.click();
//   }


const timeoutId = setTimeout(() => {
    //console.log('sleep');
    if (element &&  this.offerleadid  != undefined )
    {
      element.click();
    clearTimeout(timeoutId)
  }
    // And any other code that should run only after 5s
  }, 100);


  // later on


  
}





 

  // on click of product

  onClickOfProduct(data, i) {
    debugger
    if (this.companySpecificpage) {
      debugger
      this.calculatorService.SearchCategory = '3';
      // this.getDefaultOffers(data.sub_product_id, 1); // in company specific page only salaried 
      this.calculatorService.loading = true;
      this.getQuestionsByProductId(data.sub_product_id, data.question_type, data.bank_id, 1, data.list_type);
    }
    this.product.productId = data.id;
    this.calculatorService.activeProduct = data.id;
    this.product.questionType = data.question_type;
    this.product.bankId = data.bank_id;
    this.product.listId = data.list_type;
  }

  getQuestionsByProductId_forsingle_status(status){
    this.product.status = status.id;
    this.calculatorService.activeStatus = status.id;
    this.product.statusId = status.id;
    this.calculatorService.SearchCategory = '3';
    //  this.getDefaultOffers(this.product.productId, status.id);

    this.calculatorService.loading = true;
    this.getQuestionsByProductId(this.product.productId, this.product.questionType, this.product.bankId, status.id,  this.product.listId,status,this.productList);
  }
  // on click of status
  onClickOfStatus(status) {
    debugger
    this.product.status = status.id;
    this.calculatorService.activeStatus = status.id;
    this.product.statusId = status.id;
    this.calculatorService.SearchCategory = '3';
    //  this.getDefaultOffers(this.product.productId, status.id);
    debugger;
    this.calculatorService.loading = true;
    this.getQuestionsByProductId(this.product.productId, this.product.questionType, this.product.bankId, status.id, this.product.listId,status,this.productList );
  }

  // Dynamic Component Loading
  private getQuestions(productId: any, questionType: any, bankId: any, statusId: any, listId: any,statusData:any,productList:any) {
    return [
      new WidgetReportItem(QuestionsComponent, {
        configData: this.dataList, productId: productId, questionType: questionType, bankId: bankId,
        statusId: statusId, listId: listId, inputData: this.inputValuesList ,statusData:statusData,productList:productList,
      }),
    ];
  }

  // Get questions based on product Id

  getQuestionsByProductId(productId, questionType, bankId, status, listId,statusData=null,productList=null) {
    this.httpService.getById(emiGlobals.productQuestionUrl + '/' + productId + '/' + status).subscribe(result => {
      this.dataList = result;
      let postItems: any = [];
      debugger;
      postItems = this.getQuestions(productId, questionType, bankId, status, listId,statusData,productList);
      this.widgetHostService.loadReportComponent(this.bank.viewContainerRef, postItems[0]);
    });
  }

  // on Tab Click

  onTabClick(id) {
    this.calculatorService.noOffer = false;
    this.calculatorService.SearchCategory = id;
  }
  //  Get All Products List
  getAllProducts(url) {

    // To get main product by url
    this.httpService.getAll(emiGlobals.mainProductByUrlCategory + '/' + url).subscribe(result => {

      // Get sub-product-id from response
      if (result.products[0].sub_product_id) {
        this.productId = result.products[0].sub_product_id.split(',');
        this.productId.forEach(productId => {

          // get sub product by id
          this.httpService.getAll(emiGlobals.productById + '/' + productId).subscribe(data => {
            let product = {
              'id': data[0].id,
              'product': data[0].product,
              'question_type': data[0].question_type,
              'list_type': data[0].list_type
            };

            this.productList.push(product);
          });
           this.httpService
            .getAll(emiGlobals.statusUrl + '/'+ productId)
              .subscribe((result) => {
    
              this.statusList = result.status;
              console.log('Status List is', this.statusList);

              setTimeout(() => {
                // Perform the next step here directly
                if( this.statusList.length === 1 ){
                  this. getQuestionsByProductId_forsingle_status(this.statusList[0]);
                
                }
  
                console.log('Next action triggered after 5 seconds');
                // You can call your next logic or method here
              }, 50);

              
            });
        });
      }
    });
  }
  // Get Default Offers
  getDefaultOffers(productId, statusId) {
    this.productOffer.product = productId;
    this.productOffer.statusId = statusId;
    const myDate = new Date();
    this.productOffer.currentDate = this.datePipe.transform(myDate, 'yyyy-MM-dd');
    this.httpService.create(emiGlobals.defaultOfferUrl, this.productOffer).subscribe(result => {
      const value = JSON.parse(result._body);
      this.calculatorService.getCurrentData(value);
      this.inputValuesList = value.inputValues;
      localStorage.setItem('salaryBank', this.inputValuesList[0].salaryAccountBank);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/calculators/home-loan-comparison-calculator/dynamic-products/dynamic-products.component.ts